import * as queryString from 'query-string';
import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';
import _ from 'underscore';

import { AuthenticateConnection } from '~src/connectivity/components/AuthenticateConnection';

import WebHttpClient from '../../../httpClient/WebHttpClient';
import { GetDataConnectionAuthInfoRequest } from '../../../ts/ServerApi/requests/GetDataConnectionAuthInfoRequest';
import { IDataConnectionAuthInfo } from '../../../ts/ServerApi/types/IDataConnectionAuthInfo';

export interface AuthenticateConnectionRouterProps { }

/**
 * This is the authenticate data connection UI used as a fallback when signing into a data connection on the viz page.
 * It is then shown through viz client in an iframe.
 * The path is just a plain /authenticate regardless of site
 */
export class AuthenticateConnectionRouter extends React.PureComponent<AuthenticateConnectionRouterProps> {
  public render() {
    return (
      <Route path={'/authenticate'} render={this.provider} />
    );
  }

  private provider = (routeProps: RouteComponentProps) => {
    return <AuthenticateConnectionProvider
      routeLocationSearch={routeProps.location.search}
    />;
  }
}

interface AuthenticateConnectionProviderProps {
  readonly routeLocationSearch: string;
}

interface AuthenticateConnectionProviderState {
  readonly authInfo: IDataConnectionAuthInfo;
}
class AuthenticateConnectionProvider extends React.PureComponent<AuthenticateConnectionProviderProps, AuthenticateConnectionProviderState> {
  private unmounted: boolean = false;

  public constructor(props: AuthenticateConnectionProviderProps) {
    super(props);
    this.state = { authInfo: undefined };
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidMount = async () => {
    // We expect following query values  //?path&attributes&vizqlSessionId&isPreview&closePopupWhenDone&disableSessionPing',
    const currentQueryValues = queryString.parse(this.props.routeLocationSearch);
    const authInfo = await WebHttpClient.sendRequest(new GetDataConnectionAuthInfoRequest(currentQueryValues));
    if (!this.unmounted) {
      this.setState({ authInfo });
    }
  }

  public render() {
    if (!_.isUndefined(this.state.authInfo)) {
      return <AuthenticateConnection
        authInfo={this.state.authInfo}
        queryParams={queryString.parse(this.props.routeLocationSearch)}
      />;
    } else {
      return null;
    }
  }

}
